import request from '@/utils/request';
//快捷规则管理规则列表
export function getMdRuleList(param) {
  return request('/decision/model/model-expression', {
    method: 'GET',
    params: param,
  });
}

//保存所有临时变量条件
export function saveMdRuleList(values) {
  return request('/decision/model/model-expression', {
    method: 'POST',
    data: values,
  });
}
//编辑输出列表
export function editOutputList(values) {
  const { ruleOutputId } = values || {};
  values['ruleOutputId'] = undefined;
  return request(`/decision/rule/rule-output-item/${ruleOutputId}`, {
    method: 'PUT',
    data: values,
  });
}

//新增输出列表
export function addOutputList(values) {
  return request('/decision/rule/rule-output-item', {
    method: 'POST',
    data: values,
  });
}
//删除输出列表
export function deleteOutputList(values) {
  const { id } = values || {};
  return request(`/decision/rule/rule-output-item/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//规则列表
export function getRuleList(param) {
  return request('/decision/rule/combine-relation', {
    method: 'GET',
    params: param,
  });
}
//保存单一规则列表
export function saveRuleList(values) {
  return request('/decision/rule/combine-relation/single', {
    method: 'POST',
    data: values,
  });
}
//
export function saveMultipleRuleList(values) {
  return request('/decision/rule/combine-relation/multiple', {
    method: 'POST',
    data: values,
  });
}
//删除规则列表
export function deleteRuleList(values) {
  const { id } = values || {};
  return request(`/decision/rule/combine-relation/regularExpression/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//删除规则列表多个
export function deleteMulRuleList(values) {
  const { relationId } = values || {};
  return request(`/decision/rule/combine-relation/${relationId}`, {
    method: 'DELETE',
    // data: values,
  });
}
